import { gql } from "@apollo/client";



export const QUERY_DISTRICT_REPORTS = gql`
  query districtReports($searchCriteria: String, $districtIds: [ID], $reportGroup: String) {
    districtReports(searchCriteria: $searchCriteria, districtIds: $districtIds, reportGroup: $reportGroup) {
      id
      districtId
      district {
        id
        name
        address
        city
        state
        zip
        phone
        fax
        website
      }
      isBaseReport
      isUserReport
      userId
      user {
        email
      }
      baseReportId
      baseReport {
        id
        reportName
        reportGroup
        fields {
          fieldName
          fieldGroup
          fieldCaption
          fieldOrder
          fieldWidth
          fieldAlignment
          fieldHasFilter
          fieldHasSort
          dataType
          dataFormat
          visible
          default
          required
        }
      }
      reportCode
      reportName
      reportTitle
      reportGroup
      reportNotes
      reportRowNotes {
        rowId
        notes
      }
      reportParameters
      selectedFields {
        fieldName
        fieldGroup
        fieldCaption
        fieldOrder
        fieldWidth
        fieldAlignment
        dataType
        dataFormat        
        fieldHasFilter
        fieldHasSort
        tooltipText
        visible
        default
        required
      }
      reportColumns
      filterValues
      grouping {
        fieldName
        function
        includeGrandTotal
      }
      distribution {
        emailRecipients {
          email
        }
        emailFrom
        emailSubject
        emailText
        emailAttachments
      }
      schedule {
        scheduleActive
        recurrenceTimePeriod
        recurrenceInterval
        recurrencePeriods
        recurrenceDayNumber
        recurrenceDate
        scheduleStartDate
        scheduleEndDate
      }
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
      hidden
    }
  }
`;

export const QUERY_DISTRICT_REPORT = gql`
  query districtReport($id: ID!) {
    districtReport(id: $id) {
      id
      districtId
      district {
        id
        name
        address
      }
      userId
      isUserReport
      baseReportId
      baseReport {
        id
        fields {
          fieldName
          fieldGroup
          fieldCaption
          fieldOrder
          fieldWidth
          fieldAlignment
          fieldHasFilter
          fieldHasSort
          dataType
          dataFormat
          visible
          default
          required
        }
      }
      reportCode
      reportName
      reportTitle
      reportGroup
      reportNotes
      reportRowNotes {
        rowId
        notes
      }
      reportParameters
      selectedFields {
        fieldName
        fieldGroup
        fieldCaption
        fieldOrder
        fieldWidth
        fieldAlignment
        dataType
        dataFormat        
        fieldHasFilter
        fieldHasSort
        tooltipText
        visible
        default
        required
      }
      reportColumns
      filterValues
      grouping {
        fieldName
        function
        includeGrandTotal
      }
      distribution {
        emailRecipients {
          email
        }
        emailFrom
        emailSubject
        emailText
        emailAttachments 
      }
      schedule {
        scheduleActive
        recurrenceTimePeriod
        recurrenceInterval
        recurrencePeriods
        recurrenceDayNumber
        recurrenceDate
        scheduleStartDate
        scheduleEndDate
      }
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
      hidden
      createdBy
      createdAtAgo
      updatedAtAgo
      createdAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
      updatedAt(format: "ddd mmm dd yyyy h:MM:ss TT Z")
    }
  }
`;

export const QUERY_USER_DISTRICT_REPORTS = gql`
  query userDistrictReports($districtIds: [ID], $reportGroup: String, $searchCriteria: String) {
    userDistrictReports(districtIds: $districtIds, reportGroup: $reportGroup, searchCriteria: $searchCriteria) {
      id
      districtId
      district {
        id
        name
        address
        city
        state
        zip
        phone
        fax
        website
      }
      isBaseReport
      isUserReport
      userId
      user {
        email
      }
      baseReportId
      baseReport {
        id
        reportName
        reportGroup
        fields {
          fieldName
          fieldGroup
          fieldCaption
          fieldOrder
          fieldWidth
          fieldAlignment
          fieldHasFilter
          fieldHasSort
          tooltipText
          dataType
          dataFormat
          visible
          default
          required
          linkParms {
            basePath
            pathIdField
            textField
            tooltipText
          }
        }
      }
      reportCode
      reportName
      reportTitle
      reportGroup
      reportNotes
      reportRowNotes {
        rowId
        notes
      }
      reportParameters
      selectedFields {
        fieldName
        fieldGroup
        fieldCaption
        fieldOrder
        fieldWidth
        fieldAlignment
        dataType
        dataFormat        
        fieldHasFilter
        fieldHasSort
        tooltipText
        visible
        default
        required
        linkParms {
          basePath
          pathIdField
          textField
          tooltipText
        }
      }
      reportColumns
      reportTableFilters
      reportTableSorter
      grouping {
        fieldName
        function
        includeGrandTotal
      }
      distribution {
        emailRecipients {
          email
        }
        emailFrom
        emailSubject
        emailText
        emailAttachments
      }
      schedule {
        scheduleActive
        recurrenceTimePeriod
        recurrenceInterval
        recurrencePeriods
        recurrenceDayNumber
        recurrenceDate
        scheduleStartDate
        scheduleEndDate
      }
      pageLayout {
        pageFormat
        pageHeight
        pageWidth
        pageOrientation
        pageMargins
        marginTop
        marginBottom
        marginLeft
        marginRight
        fontName
        fontStyle
        fontSize
      }
      hidden
    }
  }
`;

export const QUERY_DISTRICT_REPORTS_LIST = gql`
  query districtReports($districtIds: [ID], $searchCriteria: String) {
    districtReports(districtIds: $districtIds, searchCriteria: $searchCriteria) {
      id
      districtId
      userId
      isUserReport
      baseReportId
      reportCode
      reportName
      reportGroup
      hidden
    }
  }
`;

export const QUERY_USER_DISTRICT_REPORTS_LIST = gql`
  query userDistrictReports($userId: ID, $districtIds: [ID], $searchCriteria: String) {
    userDistrictReports(userId: $userId, districtIds: $districtIds, searchCriteria: $searchCriteria) {
      id
      districtId
      userId
      isUserReport
      baseReportId
      reportCode
      reportName
      reportGroup
      hidden
    }
  }
`;